var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tabs",
    { attrs: { grow: "" } },
    [
      _c("v-tab", { attrs: { href: "#tab-profileInfo" } }, [
        _vm._v(" Profile Info "),
      ]),
      _c("v-tab", { attrs: { href: "#tab-inputs" } }, [_vm._v(" Inputs ")]),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-profileInfo" } },
        [
          _c(
            "v-scroll-y-transition",
            { attrs: { mode: "out-in" } },
            [
              !_vm.profile
                ? _c(
                    "div",
                    {
                      staticClass:
                        "title grey--text text--lighten-1 font-weight-light",
                      staticStyle: { "align-self": "center" },
                    },
                    [_vm._v(" Select a Profile ")]
                  )
                : _c(
                    "v-card",
                    { key: _vm.profile.id, attrs: { flat: "" } },
                    [
                      _c("v-card-title", [
                        _c("div", { staticClass: "mb-2" }, [
                          _vm._v(_vm._s(_vm.profile.data.title)),
                        ]),
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-row",
                        {
                          staticClass: "text-left pa-4",
                          attrs: { dense: "", "data-cy": "profileInfoFields" },
                        },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _vm.from_file
                              ? _c("div", [
                                  _c("strong", [_vm._v("From File:")]),
                                  _vm._v(" " + _vm._s(_vm.from_file) + " "),
                                ])
                              : _vm._e(),
                            _vm.version
                              ? _c("div", [
                                  _c("strong", [_vm._v("Version:")]),
                                  _vm._v(" " + _vm._s(_vm.version)),
                                ])
                              : _vm._e(),
                            _vm.sha256_hash
                              ? _c("div", [
                                  _c("strong", [_vm._v("SHA256 Hash:")]),
                                  _vm._v(" " + _vm._s(_vm.sha256_hash) + " "),
                                ])
                              : _vm._e(),
                            _vm.maintainer
                              ? _c("div", [
                                  _c("strong", [_vm._v("Maintainer:")]),
                                  _vm._v(" " + _vm._s(_vm.maintainer) + " "),
                                ])
                              : _vm._e(),
                            _vm.copyright
                              ? _c("div", [
                                  _c("strong", [_vm._v("Copyright:")]),
                                  _vm._v(" " + _vm._s(_vm.copyright) + " "),
                                ])
                              : _vm._e(),
                            _vm.copyright_email
                              ? _c("div", [
                                  _c("strong", [_vm._v("Copyright Email:")]),
                                  _vm._v(
                                    " " + _vm._s(_vm.copyright_email) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.control_count
                              ? _c("div", [
                                  _c("strong", [_vm._v("Control Count:")]),
                                  _vm._v(" " + _vm._s(_vm.control_count) + " "),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-inputs" } },
        [
          _c(
            "v-scroll-y-transition",
            { attrs: { mode: "out-in" } },
            [
              !_vm.profile
                ? _c(
                    "div",
                    {
                      staticClass:
                        "title grey--text text--lighten-1 font-weight-light",
                      staticStyle: { "align-self": "center" },
                    },
                    [_vm._v(" Select a Profile ")]
                  )
                : _c(
                    "v-card",
                    { key: _vm.profile.id, attrs: { flat: "" } },
                    [
                      _c("v-card-title", [
                        _c("div", { staticClass: "mb-2" }, [
                          _vm._v(
                            "Inputs for " + _vm._s(_vm.profile.data.title)
                          ),
                        ]),
                      ]),
                      _vm.inputs.length !== 0
                        ? _c(
                            "div",
                            [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.inputs,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: `item.options`,
                                      fn: function ({ item }) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.options.value) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [_c("v-card-text", [_vm._v(" No inputs found. ")])],
                            1
                          ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }